import { NoFound } from './NoFound';

export default NoFound;
